<template>
  <div>
    <h6 class="aside-title">Pipelines</h6>
    <ul class="list-unstyled mobile-pipeline">
      <li class="mb-3">
        <img src="/img/rank0.svg" alt="rating icon" />
        <a class="username mb-2" href="#">Technical Writer</a>
        <div class="d-flex main mb-1">
          <span>Blue Coral Solutions / Self-Employed</span>
          <span>
            18-07-2020 13:21
          </span>
        </div>
        <div class="d-flex mb-2">
          <span>Varna, Province</span>
          <span> <span class="status"></span> Not contacted </span>
        </div>
      </li>
      <li class="mb-3">
        <img src="/img/rank0.svg" alt="rating icon" />
        <a class="username mb-2" href="#">Q&A Tester</a>
        <div class="d-flex main mb-1">
          <span>Blue Coral Solutions / Self-Employed</span>
          <span>
            18-07-2020 13:21
          </span>
        </div>
        <div class="d-flex mb-2">
          <span>Varna, Province</span>
          <span> <span class="status employment"></span> Contacted </span>
        </div>
      </li>
      <li class="mb-3">
        <img src="/img/rank0.svg" alt="rating icon" />
        <a class="username mb-2" href="#">SEO engeneer</a>
        <div class="d-flex main mb-1">
          <span>Blue Coral Solutions / Self-Employed</span>
          <span>
            18-07-2020 13:21
          </span>
        </div>
        <div class="d-flex mb-2">
          <span>Varna, Province</span>
          <span> <span class="status"></span> Not contacted </span>
        </div>
      </li>
      <li class="mb-3">
        <img src="/img/rank0.svg" alt="rating icon" />
        <a class="username mb-2" href="#">Backend Developer</a>
        <div class="d-flex main mb-1">
          <span>Blue Coral Solutions / Self-Employed</span>
          <span>
            18-07-2020 13:21
          </span>
        </div>
        <div class="d-flex mb-2">
          <span>Varna, Province</span>
          <span> <span class="status"></span> Not contacted </span>
        </div>
      </li>
      <li class="mb-3">
        <img src="/img/rank0.svg" alt="rating icon" />
        <a class="username mb-2" href="#">Backend Developer</a>
        <div class="d-flex main mb-1">
          <span>Blue Coral Solutions / Self-Employed</span>
          <span>
            18-07-2020 13:21
          </span>
        </div>
        <div class="d-flex mb-2">
          <span>Varna, Province</span>
          <span> <span class="status"></span> Not contacted </span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  components: {},
  data: () => ({
    jobs: [
      {
        id: 1,
        title: 'Technical Writer',
        place: 'Sofia, Iztok',
        company: 'Company',
        publishedDate: '26-06-19',

        stage: 'closed',
        empType: 'Freelance',
      },
      {
        id: 2,
        title: 'Tester',
        place: 'Sofia, Iztok',
        company: 'Company',
        publishedDate: '26-06-19',

        stage: 'closed',
        empType: 'Freelance',
      },
      {
        id: 3,
        title: 'Developer',
        place: 'Sofia, Iztok',
        company: 'Company',
        publishedDate: '10-06-19',

        stage: 'closed',
        empType: 'Freelance',
      },
      {
        id: 4,
        title: 'DevOps',
        place: 'Sofia, Iztok',
        company: 'Comstream',
        publishedDate: '26-06-19',

        stage: 'closed',
        empType: 'Freelance',
      },
      {
        id: 5,
        title: 'QA',
        place: 'Sofia, Iztok',
        company: 'Company',
        publishedDate: '26-06-19',

        stage: 'closed',
        empType: 'Freelance',
      },
    ],
  }),
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.location-color {
  color: $color-table-location;
}

.jobs-controls {
  .input-group {
    i {
      color: $color-table-location;
      position: absolute;
      pointer-events: none;
      top: 8px;
      right: 12px;
      font-size: 21px;
      z-index: 99;
    }
    .form-control {
      border-radius: 0.25rem !important;
    }
  }
}

@media only screen and (max-width: 576px) {
  .dropdown.ml-3 {
    margin-left: 0 !important;
    .btn {
      width: 100%;
      margin: 12px 0;
    }
  }
  .mobile-pipeline {
    display: block;
  }
  .bottom-controls,
  .no-mobile {
    display: none !important;
  }
  .jobs-controls {
    .d-flex {
      display: block !important;
      .input-group {
        width: 100% !important;
      }
    }
    .dropup,
    .dropright,
    .dropdown,
    .dropleft {
      background: red;
    }
  }

  .list-unstyled.mobile-pipeline {
    font-family: $font-family-sans-lato;
    li {
      position: relative;
      padding: 6px 22px 6px 22px;
      border-bottom: 1px solid #ddd;
      a.username {
        display: block;
        font-size: 16px;
        font-weight: 700;
        text-decoration: none;
      }

      a.toggle-collapse {
        color: #666;
        position: absolute;
        top: 50%;
        right: -2px;
        transform: translate(0, -50%);
      }

      .d-flex:first-of-type {
        span {
          font-size: 14px;
          &:first-of-type {
            color: $color-orange;
            margin-right: auto;
          }

          &:nth-of-type(2) {
            color: #5f5f5f;
          }
        }
      }

      .d-flex:nth-of-type(2) {
        span {
          font-size: 14px;

          &:first-of-type {
            color: #5f5f5f;
            margin-right: auto;
          }

          &:nth-of-type(2) {
            color: #5f5f5f;
            position: relative;
            .status {
              border-radius: 50%;
              display: inline-block;
              width: 11px;
              height: 11px;
              background: red;
              margin: 0px 5px 0 0;
              &.employment {
                background: $color-status-active;
              }
              &.self-employment {
                background: $color-base-blue;
              }
              &.mixed-orange {
                background: $color-orange;
              }
            }
          }
        }
      }
      img {
        position: absolute;
        top: 8px;
        right: 22px;
      }
    }
  }
}

.dropdown {
  button {
    box-shadow: 0px 2px 3px #0000000d;
    background: url("data:image/svg+xml;utf8,<svg viewBox='0 0 140 140' width='14' height='14' xmlns='http://www.w3.org/2000/svg'><g><path d='m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z' fill='grey'/></g></svg>")
      no-repeat !important;
    background-position: right 3px top 50% !important;
    margin-right: 3px !important;
    -webkit-appearance: none;
    -moz-appearance: none;

    &::after {
      display: none;
      /*  -webkit-appearance: none;
      -moz-appearance: none; */
    }
    color: #4d4f5c;
  }

  .dropdown-menu {
    padding: 8px 12px;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.4);
    ul > li:not(:last-child) {
      margin-bottom: 1rem;
    }

    width: 250px;
    margin-top: 5px;

    .custom-control {
      margin-bottom: 0;
    }
  }

  button {
    background-color: #fff;
    border: 1px solid #d7dae2;
    border-radius: 4px;
    width: 250px;
    text-align: left;
  }
}

.mobile-pipeline {
  display: none;
}

@media only screen and (max-width: 992px) {
    .aside-title {
    display: none !important;
  }
  .mobile-pipeline {
    display: block;
  }
  .list-unstyled.mobile-pipeline {
    font-family: $font-family-sans-lato;
    li {
      position: relative;
      padding: 6px 22px 6px 22px;
      border-bottom: 1px solid #ddd;
      a.username {
        display: block;
        font-size: 16px;
        font-weight: 700;
        text-decoration: none;
      }

      a.toggle-collapse {
        color: #666;
        position: absolute;
        top: 50%;
        right: -2px;
        transform: translate(0, -50%);
      }

      .d-flex:first-of-type {
        span {
          font-size: 14px;
          &:first-of-type {
            color: $color-orange;
            margin-right: auto;
          }

          &:nth-of-type(2) {
            color: #5f5f5f;
          }
        }
      }

      .d-flex:nth-of-type(2) {
        span {
          font-size: 14px;

          &:first-of-type {
            color: #5f5f5f;
            margin-right: auto;
          }

          &:nth-of-type(2) {
            color: #5f5f5f;
            position: relative;
            .status {
              border-radius: 50%;
              display: inline-block;
              width: 11px;
              height: 11px;
              background: red;
              margin: 0px 5px 0 0;
              &.employment {
                background: $color-status-active;
              }
              &.self-employment {
                background: $color-base-blue;
              }
              &.mixed-orange {
                background: $color-orange;
              }
            }
          }
        }
      }
      img {
        position: absolute;
        top: 8px;
        right: 22px;
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .mobile-pipeline {
    display: block;
  }
  .aside-title {
    display: none !important;
  }
  .list-unstyled.mobile-pipeline {
    font-family: $font-family-sans-lato;
    li {
      position: relative;
      padding: 6px 22px 6px 15px;
      border-bottom: 1px solid #ddd;
      a.username {
        display: block;
        font-size: 16px;
        font-weight: 700;
        text-decoration: none;
      }

      a.toggle-collapse {
        color: #666;
        position: absolute;
        top: 50%;
        right: -2px;
        transform: translate(0, -50%);
      }

      .d-flex:first-of-type {
        span {
          font-size: 14px;
          &:first-of-type {
            color: $color-orange;
            margin-right: auto;
          }

          &:nth-of-type(2) {
            color: #5f5f5f;
          }
        }
      }

      .d-flex:nth-of-type(2) {
        span {
          font-size: 14px;

          &:first-of-type {
            color: #5f5f5f;
            margin-right: auto;
          }

          &:nth-of-type(2) {
            color: #5f5f5f;
            position: relative;
            .status {
              border-radius: 50%;
              display: inline-block;
              width: 11px;
              height: 11px;
              background: red;
              margin: 0px 5px 0 0;
              &.employment {
                background: $color-status-active;
              }
              &.self-employment {
                background: $color-base-blue;
              }
              &.mixed-orange {
                background: $color-orange;
              }
            }
          }
        }
      }
      img {
        position: absolute;
        top: 8px;
        right: 22px;
      }
    }
  }
}

@media only screen and (max-width: 576px) {
  .aside-title {
    display: block !important;
    margin-top: 33px !important;
  }
}
</style>
